import Link from 'next/link'

export default function PreNavbar() {
  return (
    <>
      <div className='bg-[#06476d] text-white fixed z-[999] w-full'>
          <div className='grid grid-cols-2 lg:px-0 justify-items-center'>
            <Link
              className='font-bold py-2 hover:bg-yellow-500 hover:text-black transition-colors duration-300 w-full text-center'
              href="https://sga.ciebe.com.br/login"
            >
              <span className='hidden lg:inline'>Acessar</span> Portal GRADUAÇÃO
            </Link>
            <Link
              className='font-bold py-2 hover:bg-yellow-500 hover:text-black transition-colors duration-300 w-full text-center'
              href="https://www.estudesemfronteiras.com"
            >
              <span className='hidden lg:inline'>Acessar</span> Portal PÓS-GRADUAÇÃO
            </Link>
          </div>
      </div>
    </>
  )
}
